/* eslint-disable react/self-closing-comp */
/* eslint-disable vars-on-top */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable no-redeclare */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */

import React from 'react';
import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux'

import BackButton from '../../components/BackButton/BackButton';
import styles from "./RequestorDashboard.module.css";
import  RequestorDashboardForm  from "../../components/RequestorDashboardForm/RequestorDashboardForm";
import { CustomTab } from '../../atomicComponents';
import UserInfoPanel from '../../atomicComponents/UserInfoPanel/UserInfoPanel';

function RequestorDashboard({product}) {
  const history = useHistory();
  const redirectToProcessPage = () => {
    history.push('/home');
  };


  return (
    <>
      <div className={styles.container} style={{ boxSizing: 'border-box' }}>
          <div className={styles.backButtonLastRefreshedDateWrapper} style={{display:"none"}}>

          <BackButton
            action="Home"
            handleClick={redirectToProcessPage}
          />
        </div>
        <div className={styles.processHeader}>
          <div className={styles.CustomTabClass}>
            <CustomTab title="Request Dashboard" withOutCount isSelected />
          </div>
          <div className={styles.processTopbar} style={{}}>

          <UserInfoPanel
                userInfo={[
                  {
                    "Name": "Pratik Tarade",
                    "SAP ID": 122366,
                    "BC No": "122366",
                    "LOC": "Engineering and Research Center",
                  },
                ]}
              />
              </div>
 </div>
     
        <RequestorDashboardForm redirectToProcessPage={redirectToProcessPage}/>

      </div>
    </>
  )
}
const mapStateToProps = state => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({

});
RequestorDashboard.propTypes = {

  product: PropTypes.object,

};
export default connect(mapStateToProps, mapDispatchToProps)(RequestorDashboard); 
